import script from "./DogDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./DogDetail.vue?vue&type=script&setup=true&lang=js"

import "./DogDetail.vue?vue&type=style&index=0&id=4d451cbc&lang=scss&scoped=true"

import exportComponent from "/var/www/application-mobile/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d451cbc"]])

export default __exports__